module.exports = __webpack_public_path__ + "img/certificate2-05.72aa4095.png";